export function boxReducer(state = {
    LINKED : null,
    FREE : null,
    SWITCHED : null,
    ALL : null,
},{
    type,
    payload
}){
    switch(type){
        case "GET_BOXES":
            let state0 = Object.assign({}, state)
            state0.ALL = payload
            state0.ALL = state0.ALL ? Object.assign(state0.ALL, payload) : state0.ALL = payload
            return state0
        
        case "GET_LINKED_BOXES":
            let state1 = Object.assign({}, state)
            state1.LINKED = payload
            state1.ALL = state1.ALL ? Object.assign(state1.ALL, payload) : state1.ALL = payload
            return state1
        
        case "GET_FREE_BOXES":
            let state2 = Object.assign({}, state)
            state2.FREE = payload
            state2.ALL = state2.ALL ? Object.assign(state2.ALL, payload) : state2.ALL = payload
            return state2
        
        default:
            return state;
    }
}